import { Box } from "@mui/material";
import React from "react";

export default function SchoolView(props) {
	return (
		<Box>
			School page
		</Box >
	);
}